import { render } from "./Soli-Credito.vue?vue&type=template&id=f779ab52&scoped=true"
import script from "./Soli-Credito.vue?vue&type=script&lang=js"
export * from "./Soli-Credito.vue?vue&type=script&lang=js"

import "./Soli-Credito.vue?vue&type=style&index=0&id=f779ab52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f779ab52"]])

export default __exports__